import { render, staticRenderFns } from "./StockControl.vue?vue&type=template&id=85ff4c08&scoped=true&"
import script from "./StockControl.vue?vue&type=script&lang=js&"
export * from "./StockControl.vue?vue&type=script&lang=js&"
import style0 from "./StockControl.vue?vue&type=style&index=0&id=85ff4c08&scoped=true&lang=css&"
import style1 from "./StockControl.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ff4c08",
  null
  
)

export default component.exports
import {QItem,QField,QCheckbox,QSpace,QBtn,QTooltip,QTr,QTh,QTd,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QItem,QField,QCheckbox,QSpace,QBtn,QTooltip,QTr,QTh,QTd,QInnerLoading,QSpinnerGears}, component.options.components || {})
